import { Action } from "redux"
import { createAction } from "redux-actions"
import { ThunkDispatch, ThunkAction } from "redux-thunk"
import * as Actions from "./actions"
import { NotificationLevel, NotificationParams } from "./component/notification"
import * as LocalAuthorityDomain from "./domain/sfp/local-authority-domain"
import * as Model from "./model"
import { ReducerState } from "./reducer"
import UsersService from "./service/sfp/users-service"
import * as LocalAuthorityService from "./service/sfp/local-authorities-service-2"
import { findLoans } from "./service/sfp/loans-service-2"
import { findServices } from "./service/sfp/services-service"
import * as FileService from "./service/sfp/file-service"
import * as PolitiqueServices from "./service/sfp/politique-services"
import Politique from "./component/policy/politique"
import * as ScenarioService from "./service/sfp/scenarii-service"

export function fetchCurrentLocalAuthorityIfNeeded(
	idOrSlug: string | number
): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingCurrentLocalAuthority) return

		dispatch(requestCurrentLocalAuthority(idOrSlug))
		dispatch(setLoaderValue(0))

		const localAuthority = await LocalAuthorityService
		.findLocalAuthorityByIdOrSlug(idOrSlug)
		.catch(error => {
			dispatch(dispatch(throwError(error)))
		})

		if (!localAuthority) return
		dispatch(setLoaderValue(0))
		dispatch(receiveCurrentLocalAuthority(localAuthority))
		dispatch(fetchLoans(localAuthority))
		dispatch(fetchServices(localAuthority))
	}
}

export function fetchCurrentLocalAuthorityIfCollectivitiesPage(
	idOrSlug: string | number
): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingCurrentLocalAuthority) return

		dispatch(requestCurrentLocalAuthority(idOrSlug))

		const localAuthority = await LocalAuthorityService
		.findLocalAuthorityByIdOrSlug(idOrSlug)
		.catch(error => {
			dispatch(dispatch(throwError(error)))
		})

		if (!localAuthority) return
		dispatch(receiveCurrentLocalAuthority(localAuthority))
	}
}

export function fetchCurrentUser(): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingCurrentUser) return

		dispatch(requestCurrentUser())

		const user = await UsersService.findCurrentUser()
		.catch(error => {
			dispatch(dispatch(throwError(error)))
		})

		if (user) dispatch(receiveCurrentUser(user))
	}
}

export function fetchLoans(
	localAuthority: Model.LocalAuthority
): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingCurrentLocalAuthorityLoans) return

		dispatch(requestCurrentLocalAuthorityLoans())

		const loans = await findLoans(localAuthority)
		.catch(error => {
			dispatch(dispatch(throwError(error)))
		})

		if (loans) dispatch(receiveCurrentLocalAuthorityLoans(loans))
	}
}

export function fetchServices(
	localAuthority: Model.LocalAuthority
): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingCurrentLocalAuthorityServices) return

		dispatch(requestCurrentLocalAuthorityServices())

		const services = await findServices(localAuthority)
		.catch(error => {
			dispatch(dispatch(throwError(error)))
		})

		if (services) dispatch(receiveCurrentLocalAuthorityServices(services))
	}
}

export function fetchLocalAuthorities(): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		if (getState().loadingLocalAuthorities) return

		dispatch(requestLocalAuthorities())

		const localAuthorities = await LocalAuthorityService
		.findAllLocalAuthorities()
		.catch(error => { dispatch(throwError(error)) })

		if (!localAuthorities) return

		dispatch(receiveLocalAuthorities(localAuthorities))

		if (localAuthorities.length === 1)
			dispatch(fetchCurrentLocalAuthorityIfNeeded(localAuthorities[0].id))
	}
}

export function fetchLocalAuthoritiesChildren(slug: string): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		
		dispatch(requestLocalAuthoritiesChildren())

		const localAuthorityChildren = await LocalAuthorityService
		.findAllLocalAuthoritiesChildren(slug)
		.catch(error => { dispatch(throwError(error)) })

		if (!localAuthorityChildren) return

		dispatch(receiveLocalAuthoritiesChildren(localAuthorityChildren))
	}
}

export function fetchLocalAuthoritiesDeleteChildren( LA:any ): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		let state=getState()
		let updatedData
		dispatch(requestLocalAuthoritiesChildren())
		 await LocalAuthorityService.DeleteLocalAuthoritiesChildren(LA)
		.then(res=>
			updatedData=state.localAuthoritiesChildren.filter(res1=>res1.id !== LA.id)
		)
		.catch(error => { dispatch(throwError(error)) })
		dispatch(receiveLocalAuthoritiesChildren(updatedData))
	}
}

//getAllS3Files
export function getS3FilesList(): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		
		dispatch(requestS3FilesList())
		const s3FileList = await FileService.getAllS3Files()
		.catch(error => {dispatch(throwError(error)) })

		if(!s3FileList) return
		dispatch(recieveS3FileList(s3FileList))
	}
}

export function getBudgetAnnexeCalculatedData(laId: string, scenarioId: string): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {		
		dispatch(requestBudgetAnnexeData())
		const budgetData = await ScenarioService.getBudgetAnnexeData(laId, scenarioId)
		.catch(error => {dispatch(throwError(error)) })

		if(!budgetData) return
		dispatch(recieveBudgetAnnexeData(budgetData))
	}
}

export function updateS3File(id: string, name: string): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		dispatch(requestUpdateS3FileList())
		const updateS3File = await FileService.updateS3File(id, name)
		.catch(error => {dispatch(throwError(error)) })

		if(!updateS3File) return
		dispatch(recieveUpdateS3FileList(updateS3File))
	}
}

export function uploadFileToS3(file: File): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		dispatch(uploadS3File())
		const s3FileUpload = await FileService.uploadFileToS3(file)
		.catch(error => {dispatch(throwError(error)) })

	}
}

export function deleteFileFromS3(id: string): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		dispatch(deleteS3File())
		const s3FileDelete = await FileService.deleteS3File(id)
		.catch(error => {dispatch(throwError(error)) })

		if(!s3FileDelete) return
		// dispatch(recieveS3FileList(s3FileList))
	}
}

export function uploadFileExcel(id: number,operation:string,page:string,formData:any,year:number): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		dispatch(uploadFile())
		const file = await FileService.uploadFile(id,operation,page,formData,year)
		.catch(error => {dispatch(throwError(error)) })

		if(!file) return
		dispatch(recieveuploadFile(file))
		dispatch(fetchCurrentLocalAuthorityIfNeeded(id))
	}
}


export function uploadFileXml(id: number, formData: any): ThunkAction<Promise<void>, ReducerState, undefined, Action> {
	return async (dispatch: ThunkDispatch<ReducerState, undefined, Action>) => {
		dispatch(uploadFile());
	  try {
		const result = await FileService.uploadFileObservation(id, formData);
		if (result ) {
		  dispatch(recieveuploadFile(result ));
		  dispatch(fetchCurrentLocalAuthorityIfNeeded(id));
		}
	  } catch (error) {
		dispatch(throwError(error));
		throw error;
	  }
	};
}
export function uploadFileXmlValidation(id: number, formData: any): ThunkAction<Promise<any>, ReducerState, undefined, Action> {
	return async (dispatch: ThunkDispatch<ReducerState, undefined, Action>) => {
		dispatch(uploadFile());
	  try {
		const result = await FileService.uploadFileObservationValidation(id, formData);
		if (result ) {
		  dispatch(recieveuploadFile(result ));
		  dispatch(fetchCurrentLocalAuthorityIfNeeded(id));
		  return result;
		}
	  } catch (error) {
		dispatch(throwError(error));
		throw error;
	  }
	};
}

export function allScenarios(id:number): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		
		dispatch(requestallScenarios())
		const scenarios = await PolitiqueServices.getAllScenarios(id)
		.catch(error => {dispatch(throwError(error)) })

		if(!scenarios) return
		dispatch(recieveallScenarios(scenarios))
	}
}

export function changesOnSelected(laID:number,sId:number,ppiId:number,year:number): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		
		dispatch(requestGetSelectedScenarios())
		const scenarios = await PolitiqueServices.getSelectedScenarios(laID,sId,ppiId,year)
		.catch(error => {dispatch(throwError(error)) })

		if(!scenarios) return
		dispatch(recieveGetSelectedScenarios(scenarios))
	}
}

export function saveScenarioData(data:any,id:Number,lA:any): ThunkAction<void, ReducerState, undefined, Action> {
	return async (
		dispatch: ThunkDispatch<ReducerState, undefined, Action>,
		getState: () => ReducerState
	) => {
		
		dispatch(requestSaveSelectedScenarios())
		const scenarios = await PolitiqueServices.saveSelectedScenarios(data,id)
		.catch(error => {dispatch(throwError(error)) })

		if(!scenarios) return
		dispatch(recieveSaveSelectedScenarios(scenarios))
		window.location.href = `/${lA.slug}/projection-financiere/scenarios-fonctionnement`
	}
}



export const notify = createAction(Actions.NOTIFY, (
	level: NotificationLevel,
	message: string,
	error: Error | undefined
): NotificationParams => {
	return { level, message, error, symbol: Symbol() }
})

export const receiveCurrentLocalAuthority = createAction(Actions.RECEIVE_CURRENT_LOCAL_AUTHORITY)
export const requestCurrentLocalAuthorityLoans = createAction(Actions.REQUEST_CURRENT_LOCAL_AUTHORITY_LOANS)
export const receiveCurrentLocalAuthorityLoans = createAction(Actions.RECEIVE_CURRENT_LOCAL_AUTHORITY_LOANS)
export const requestCurrentLocalAuthorityServices = createAction(Actions.REQUEST_CURRENT_LOCAL_AUTHORITY_SERVICES)
export const receiveCurrentLocalAuthorityServices = createAction(Actions.RECEIVE_CURRENT_LOCAL_AUTHORITY_SERVICES)
export const requestLocalAuthorities = createAction(Actions.REQUEST_LOCAL_AUTHORITIES)
export const receiveLocalAuthorities = createAction(Actions.RECEIVE_LOCAL_AUTHORITIES)
export const requestCurrentUser = createAction(Actions.REQUEST_CURRENT_USER)
export const receiveCurrentUser = createAction(Actions.RECEIVE_CURRENT_USER)
export const requestCurrentLocalAuthority = createAction(Actions.REQUEST_CURRENT_LOCAL_AUTHORITY)
export const setPageTitle = createAction(Actions.SET_PAGE_TITLE)
export const setLoaderValue = createAction(Actions.LOADER_DATA_VALUE)
export const throwError = createAction(Actions.THROW_ERROR)
export const updateCurrentLocalAuthority = createAction(Actions.UPDATE_CURRENT_LOCAL_AUTHORITY)
export const updateLoansLocally = createAction(Actions.UPDATE_LOANS_LOCALLY)
export const updateServicesLocally = createAction(Actions.UPDATE_SERVICES_LOCALLY)
export const unnotify = createAction(Actions.UNNOTIFY, (symbol: Symbol) => symbol)
export const requestLocalAuthoritiesChildren = createAction(Actions.REQUEST_LOCAL_AUTHORITIES_CHILDREN)
export const receiveLocalAuthoritiesChildren = createAction(Actions.RECEIVE_LOCAL_AUTHORITIES_CHILDREN)
export const clearLocalAuthoritiesChildren = createAction(Actions.CLEAR_LOCAL_AUTHORITIES_CHILDREN)
export const requestS3FilesList = createAction(Actions.REQUEST_S3_FILES_LIST)
export const recieveS3FileList = createAction(Actions.RECIEVE_S3_FILES_LIST)
export const deleteS3File = createAction(Actions.DELETE_S3_FILE)
export const uploadS3File = createAction(Actions.UPLOAD_S3_FILE)
export const requestUpdateS3FileList = createAction(Actions.REQUEST_S3_FILES_UPDATE)
export const recieveUpdateS3FileList = createAction(Actions.RECIEVE_S3_FILES_UPDATE)
export const setSelectedPriorities = createAction(Actions.SELECTED_PRIORITIES)
export const requestallScenarios = createAction(Actions.REQUEST_ALL_SCENARIOS)
export const recieveallScenarios = createAction(Actions.RECIEVE_ALL_SCENARIOS)
export const requestGetSelectedScenarios = createAction(Actions.REQUEST_SELECTED_SCENARIOS)
export const recieveGetSelectedScenarios = createAction(Actions.RECIEVE_SELECTED_SCENARIOS)
export const requestSaveSelectedScenarios = createAction(Actions.REQUEST_SELECTED_SCENARIOS_DATA)
export const recieveSaveSelectedScenarios = createAction(Actions.RECIEVE_SELECTED_SCENARIOS_DATA)
export const uploadFile = createAction(Actions.REQUEST_UPLOAD_FILE)
export const recieveuploadFile = createAction(Actions.RECIEVE_UPLOAD_FILE)
export const requestBudgetAnnexeData = createAction(Actions.REQUEST_BUDGET_ANNEXE_DATA)
export const recieveBudgetAnnexeData = createAction(Actions.RECIEVE_BUDGET_ANNEXE_DATA)
export const fetchedTableDataValue = createAction(Actions.RECIEVE_TABLE_DATA)

export const setTotalCalls = createAction(Actions.SET_TOTAL_CALLS)
export const incrementCall  = createAction(Actions.INCREMENT_CALL)
export const finishCall = createAction(Actions.FINISH_CALL)
export const allCallsFinished = createAction(Actions.SET_ALL_CALLS_FINISHED)
export const reset_OnGoinCall = createAction(Actions.RESET_ONGOIN_CALL)





// WEBPACK FOOTER //
// ./src/action-creators.ts